import app from 'flarum/forum/app';
import extractText from 'flarum/common/utils/extractText';
// A card as cardLabels() names it.
export function cardSummary(entry) {
  return {
    no: entry.no(),
    canonicalName: entry.speciesDisplay()?.canonicalName ?? null,
    vernacularName: entry.vernacularName()
  };
}

/**
 * Cards named for a warning (a species or a number already taken):
 * "n° 285a Clitocybe gilva (Clitocybe jaunâtre)" - a société without
 * numbers (Neuchâtel) has only the names to tell its cards apart.
 */
export default function cardLabels(cards) {
  const t = function (key, params) {
    if (params === void 0) {
      params = {};
    }
    return extractText(app.translator.trans(`champis-exhibitions.forum.cartotheque_page.${key}`, params));
  };
  return cards.map(card => {
    const name = card.canonicalName || t('unknown_species');
    const no = card.no ? `${t('card_number', {
      no: card.no
    })} ` : '';
    const vernacular = card.vernacularName ? ` (${card.vernacularName})` : '';
    return `${no}${name}${vernacular}`;
  }).join(', ');
}
flarum.reg.add('champis-exhibitions', 'forum/utils/cardLabels', cardLabels);